/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import WorkDetails from '../WorkDetails';
import RelatedWorks from '../RelatedWorks';
import {
  EXPLORE_MORE_LIKE_THIS_LABEL,
  EXPLORE_WORK_DETAILS_LABEL
} from '../../lib/analytics';
import { UniqueWithinTypeDecode } from '../../apollo/uniqueWithinType';
import withAnalytics from '../../containers/redux/withAnalytics';

const RelatedWorksWithAnalytics = withAnalytics(RelatedWorks);
RelatedWorksWithAnalytics.displayName = RelatedWorks.displayName;
const WorkDetailsWithAnalytics = withAnalytics(WorkDetails);
WorkDetailsWithAnalytics.displayName = WorkDetails.displayName;

class Work extends Component {
  componentDidMount() {
    this.sendViewEvents();
  }

  componentDidUpdate(prevProps) {
    const { work } = this.props;
    if (work.id !== prevProps.work.id) {
      this.sendViewEvents();
    }
  }

  sendViewEvents() {
    const { work, userViewedWork } = this.props;
    userViewedWork({ workId: UniqueWithinTypeDecode(work.id) });
  }

  render() {
    const { work, userInfo } = this.props;
    const workId = UniqueWithinTypeDecode(work.id);

    return (
      <div>
        <WorkDetailsWithAnalytics
          userInfo={userInfo}
          work={work}
          analyticsLabel={EXPLORE_WORK_DETAILS_LABEL}
        />
        <RelatedWorksWithAnalytics
          userInfo={userInfo}
          workId={workId}
          analyticsLabel={EXPLORE_MORE_LIKE_THIS_LABEL}
        />
      </div>
    );
  }
}

Work.propTypes = {
  work: PropTypes.shape({
    id: PropTypes.string.isRequired
  }).isRequired,
  userViewedWork: PropTypes.func
};

Work.defaultProps = {
  userViewedWork: () => {}
};

Work.displayName = 'Work';

Work.fragment = gql`
  fragment Work on Work {
    id
    ...${WorkDetails.displayName}
  }
  ${WorkDetails.fragment}
`;

export default Work;
